import React,{useState} from 'react'
import {Button,Box,Typography} from '@mui/material'
import CircularProgress,{CircularProgressProps} from '@mui/material/CircularProgress';
import clinicService from '../../../../../services/clinic.service';
import { useParams } from 'react-router-dom';
import {toast} from 'react-toastify'

const MAX_FILE_SIZE_MB= 16;
const ALLOWED_FILE_TYPES =[
"image/jpeg",
"image/jpg",
"image/png",
"image/gif",
"image/bmp",
"image/tiff",
"image/svg+xml",
"image/webp",
"image/x-icon",
"image/jpeg2000",
"image/heif",
"image/heic",
"image/x-raw",
"image/x-pgf",
"application/pdf",
"application/x-pdf",
]

function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Typography variant="caption" component="div" color="text.secondary">
            {`${Math.round(props.value)}%`}
          </Typography>
        </Box>
      </Box>
    );
  }
function Uploader({updateMediaList}) {
    const [selectedFile,setSelectedFile] = useState(null)
    const [error,setError] = useState(null)
    const {clinicId} = useParams()
    const [uploadProgress,setUploadProgress] = useState(0)

    const handleFileChange = (e)=>{
            const file = e.target.files[0];
            if(!ALLOWED_FILE_TYPES.includes(file.type)){
                setError("Invalid File Type. Please upload JPEG,PNG, GIF or PDF")
                return;
            }
            if(file.size > MAX_FILE_SIZE_MB * 1024 * 1024){
                setError(`File size exceeds ${MAX_FILE_SIZE_MB} MB. Please choose a smaller file.`);
                return;
            }
        setSelectedFile(file)
        setError(null)
    }
    const handleUpload = async()=>{
        if(selectedFile){
            const formData = new FormData();
            formData.append('file',selectedFile)
            //axios upload file
            try{
                const response =await clinicService.uploadMedia(clinicId,formData,
                    (progressEvent)=>{
                        const progress = (progressEvent.loaded / progressEvent.total) * 100;
                        setUploadProgress(progress)
                    }
                )
                setSelectedFile(null)
                toast.success("File Uploaded Succesfully",{
                    position: toast.POSITION.BOTTOM_RIGHT
                })
                updateMediaList()
                setUploadProgress(0)
            }catch(error){
                setSelectedFile(null)
                toast.error("Error while uploading File !",{
                    position: toast.POSITION.BOTTOM_RIGHT
                })
            }
            //clinicService.uploadMedia(clinicId,formData)
           // .then(response =>{
             //   setSelectedFile(null)
               // toast.success("File Uploaded Succesfully",{
                 //   position: toast.POSITION.BOTTOM_RIGHT
                //})
          //  })
           
        }else{
            console.log("No file selected")
        }
    }
    return (
        <Box p={3} border="1px dashed #ccc" borderRadius={8} textAlign="center">
        <input
          type="file"
          accept="image/*,.pdf"
          onChange={handleFileChange}
          style={{ display: "none" }}
          id="image-file-input"
        />
        <label htmlFor="image-file-input">
          <Button variant="outlined" component="span">
            Select Image / PDF
          </Button>
        </label>
        {selectedFile && (
          <div>
            <Typography variant="subtitle1" mt={2}>
              Selected Image: {selectedFile.name}
            </Typography>
          
            <Button
              variant="contained"
              color="primary"
              onClick={handleUpload}
              mt={2}
            >
              Upload
            </Button>
          </div>
        )}
        {uploadProgress > 0 && (
                <CircularProgressWithLabel value={uploadProgress} sx={{m:3}} />
         )}
        {error && (
          <Typography variant="body2" color="error" mt={2}>
            {error}
          </Typography>
        )}
      </Box>
  )
}

export default Uploader